export enum AppMutation {
  CHANGE_NAV_EXPAND = "CHANGE_NAV_EXPAND",
  SET_LANGUAGE = "SET_LANGUAGE",
}
